import { Protected } from '#components/patterns/routing/Protected.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';

export function HasUser({ children }: { children: React.ReactNode }) {
  const { userToken } = useAuth();

  return (
    <Protected isPermitted={() => Boolean(userToken)} redirectTo="/auth/login">
      {children}
    </Protected>
  );
}
